import styled from 'styled-components';
import type { ListStyledProps } from './List.types';

const List = styled.ul<ListStyledProps>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  li {
    list-style: none;
    display: flex;
    align-items: center;

    &:after {
      margin-left: ${({ theme }) => theme.spacing.S8};
      margin-right: ${({ theme, divider }) => (divider ? theme.spacing.S8 : 0)};
      content: ${({ divider }) => (divider ? `"${divider}"` : `""`)};
      font-family: monospace;
      color: ${({ dividerColor }) => dividerColor};
    }

    &:last-child {
      &:after {
        width: 4px;
        content: none;
        height: 100%;
      }
    }
  }
`;

export { List };
